import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import logo from '../../../src/assets/logo.png';

function FailurePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('Your payment could not be processed. Please try again.');
  
  useEffect(() => {
    const errorParam = searchParams.get('error');
    if (errorParam) {
      setError(decodeURIComponent(errorParam));
    }
  }, [searchParams]);

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <img src={logo} alt="Ixoria Logo" style={{ height: '80px', marginBottom: '20px' }} />
      </Box>
      <Box sx={{ 
        bgcolor: '#fef0f0', 
        p: 4, 
        borderRadius: 2, 
        borderLeft: '6px solid #f44336',
        mb: 4
      }}>
        <ErrorOutlineIcon sx={{ fontSize: 80, color: '#f44336', mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
          Oops! Payment Failed
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph sx={{ mb: 3 }}>
          We couldn't process your payment.
        </Typography>
        
        <Box sx={{ mt: 3, p: 3, bgcolor: 'white', borderRadius: 2, textAlign: 'left' }}>
          <Typography variant="body1" gutterBottom>
            {error || 'There was an issue processing your payment. Please try again.'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Don't worry, your card has not been charged.
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            onClick={() => navigate('/order')}
            sx={{ 
              py: 1.5, 
              borderRadius: 2,
              bgcolor: '#0a716e',
              '&:hover': {
                bgcolor: '#085b58',
              },
              px: 4
            }}
          >
            Try Again
          </Button>
          <Button 
            variant="outlined" 
            color="primary" 
            size="large"
            onClick={() => navigate('/')}
            sx={{ 
              py: 1.5, 
              borderRadius: 2,
              borderColor: '#0a716e',
              color: '#0a716e',
              '&:hover': {
                borderColor: '#085b58',
                backgroundColor: 'rgba(10, 113, 110, 0.04)'
              },
              px: 4
            }}
          >
            Return to Home
          </Button>
        </Box>
      </Box>
      
      <Box sx={{ mt: 4, p: 3, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>Need help?</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          If you're having trouble completing your purchase, please contact our support team at <strong>ixoriaherbalproject@gmail.com</strong> or call us at <strong>+91 8921074007</strong>.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Please include the following error message when contacting support:
        </Typography>
        <Box sx={{ 
          p: 2, 
          bgcolor: 'white', 
          borderRadius: 1, 
          border: '1px solid #e0e0e0',
          textAlign: 'left',
          mb: 2
        }}>
          <Typography variant="body2" fontFamily="monospace">
            {error}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          We're here to help you complete your purchase!
        </Typography>
      </Box>
      
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Thank you for choosing Ixoria. We apologize for the inconvenience and appreciate your patience.
        </Typography>
      </Box>
    </Container>
  );
}

export default FailurePage;
